
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import Text from '../../common/client/components/Text';

import ObjectInfoTitle from './ObjectInfoTitle';
import LinkToOpsub from './LinkToOpsub';

const classNames = mergeStyleSets({
    list: {
        overflowY: 'auto',
        maxHeight: 250
    },
    opsubPodil: {
        paddingLeft: 4,
        paddingRight: 4
    }
});

function getTypravText(typravKod) {
    const DATA = {
        '57': 'Právo hospodaření s majetkem státu',
        '92': 'Příslušnost hospodařit s majetkem státu',
        '109': 'Právo hospodařit s majetkem státu',
        '160': 'Hospodaření se svěřeným majetkem kraje',
    };
    return DATA[typravKod] || `ostatní - ${typravKod}`;
}

function getVlastnictvi30(vla) {
    return (vla || []).filter(item => {
        return (item.typrav_kod === '30');
    });
}

function getVlastnictviOther(vla) {
    return (vla || []).filter(item => {
        return (item.typrav_kod !== '30');
    });
}

const ObjectInfoOpsub = (props) => {
    return (
        <div>
            <Stack horizontal>
                <Stack.Item grow>
                    {(props.item.opsub_id)
                        ? <LinkToOpsub opsub={props.item} />
                        : <Text>{props.item.name}</Text>
                    }
                </Stack.Item>
                <Stack.Item className={classNames.opsubPodil}>
                    <Text bold>{props.item.podil_citatel}/{props.item.podil_jmenovatel}</Text>
                </Stack.Item>
            </Stack>
            {(props.item.typrav_kod !== '30') && <Text>({getTypravText(props.item.typrav_kod)})</Text>}
        </div>
    );
}

const ObjectInfoVlastnici = (props) => {
    return (props.vla.length > 0)
        ? <Stack.Item>
            <ObjectInfoTitle title={props.title} />
            <div className={classNames.list}>
                {props.vla.map(item => {
                    return (
                        <ObjectInfoOpsub key={item.id} item={item} />
                    )
                })}
            </div>
        </Stack.Item>
        : null;
}

const ObjectInfoVlastnictvi = (props) => {
    return (
        <React.Fragment>
            <ObjectInfoVlastnici
                title="VLASTNÍCI"
                vla={getVlastnictvi30(props.vla)}
            />
            <ObjectInfoVlastnici
                title="OSTATNÍ PRÁVNÍ VZTAHY"
                vla={getVlastnictviOther(props.vla)}
            />
        </React.Fragment>
    );
}

export default ObjectInfoVlastnictvi;
